import React from "react";

const File = ({ file, removeFile = null, selectFile= null, unselectFile= null, select =  null, unselect = null }) => {
  return (
    <div className="file-thumbnail-container">
      {file.file_type == "image" &&
        <a href={file.variant_large || file.cdn_url} className="image-link">
          <img src={file.variant_small || file.cdn_url} className="img-fluid rounded" />
        </a>
      }

      {file.file_type == "pdf" &&
        <a href={file.src} target="_blank">
          <div className="document-block">
            <div className="w-100">
              <i className="fa fa-file-pdf"></i>
              <div>
                {file.filename}
              </div>  
            </div>
          </div>
        </a>
      }

      {file.file_type == "doc" &&
        <a href={file.src} target="_blank">
          <div className="document-block">
            <div className="w-100">
            <i className="fa fa-file-alt"></i>
              <div>
                {file.filename}
              </div>  
            </div>
          </div>
        </a>
      }

      {file.file_type == "video" &&
        <div className="video-upload-block">
          <a href={`#video-modal-${file.id}`} className="video-modal">
            <div className="document-block">
              <div className="w-100">
              <video width="100%" controls>
                <source src={file.src} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              </div>
            </div>
          </a>
          <div id={`video-modal-${file.id}`} className="mfp-hide jumbotron d-flex align-content-center justify-content-center">
            <video controls style={{maxWidth: '90%', maxHeight: '70vh'}}>
              <source src={file.src} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      }

      {removeFile && 
        (<div className="file-thumbnail-action">
          <button className="btn btn-danger btn-xs"
            onClick={() => { if (window.confirm('Are you sure you wish to delete this file?')) removeFile(file) } }
          >Remove</button>
        </div>)
      }

      {select && 
        (<div className="file-thumbnail-action">
          <button className="btn btn-success btn-xs"
            onClick={() => selectFile(file) }
          >Select</button>
        </div>)
      }

      {unselect &&
        (<div className="file-thumbnail-action">
          <button className="btn btn-danger btn-xs"
            onClick={() => unselectFile(file) }
          >Remove Selection</button>
        </div>)
      }

    </div>
  )
}

export default File;